import { Component, OnInit } from '@angular/core';
import { AdminServicesService } from '../../admin-services.service';
import { ToastrService } from 'ngx-toastr';
import { saveAs } from 'file-saver';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-clients-documents',
  templateUrl: './clients-documents.component.html',
  styleUrls: ['./clients-documents.component.css']
})
export class ClientsDocumentsComponent implements OnInit {
  uploadListData: any;
  p: number = 1;
  fileName: any;
  userDtls: any;
  ID: any;
  term: string;
  constructor(public admin: AdminServicesService,
    public toastr: ToastrService,
    public router: Router,
    private httpClient: HttpClient,private SpinnerService: NgxSpinnerService ) {
    // this.userDtls = JSON.parse(localStorage.getItem('userDetails'));
    if (!localStorage.getItem('userDetails')) {
      // alert("User Already Loged out , Please Login Again");
      this.router.navigate(["login-admin"]);
    } else {
      this.userDtls = JSON.parse(localStorage.getItem('userDetails'));
    }
  } 

  ngOnInit(): void {
    this.SpinnerService.show();
    this.admin.clientDocuments().subscribe((res: any) => {
      this.SpinnerService.hide();
      this.uploadListData = res.data;
    });
  }

  selectionChanged(a){
    console.log(a);
  }

  downloadFile(files: any) {
    let obj = {
      "user_id": this.userDtls.userId,
      "file_name": files
    }
    //  let baseUrl="http://192.168.1.104:2528/";
   let  baseUrl = "https://9h6bwbaajf.execute-api.ap-south-1.amazonaws.com/dev/";
    this.httpClient.post(baseUrl + "retax_fileDownload", obj ).subscribe((res:any)=>{
      if(res.code===200){
        this.toastr.success(res.message);
      }else {
        this.toastr.error(res.message);
      }
    }
    , (err => console.error('er', err)));
    this.downloadExcelFile(files);
  }

  downloadExcelFile(data: any) {
    window.location.href = data;
  }
}
